<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="bkht_1" role="doc-chapter">
<h1 class="bkht"><span aria-label="xlviii" class="page" id="pxlviii" role="doc-pagebreak"></span><span aria-label="1" class="page" id="p1" role="doc-pagebreak"></span><a class="xref" href="#/chihayekvol190007#rbkht_1">Law, Legislation, and Liberty</a></h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hayek-vol19-0010.vue?7e0877b4